import Facebook from './facebook.repository';
import FacebookService from './facebook.service';
import facebookPages from './facebook.directive';


export default angular.module('app.facebook', [])
    .service('Facebook', Facebook)
    .service('FacebookService', FacebookService)
    .directive('facebookPages', () => new facebookPages)
    .name;